
import { applicantStore } from '@/store'
import { GeneralError } from '@/store/entities'
import { PaymentService } from '@/store/services'
import { ENVIRONMENT } from '@/commons/configuration'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { FALLBACK_LOCALE } from '@/commons/constants/locale'
import Checkbox from '@/commons/components/core/Checkbox.vue'
import { ApplicationReason } from '@/commons/constants/classifier'

@Component({
    components: {
        Checkbox
    }
})
export default class PaymentInfo extends Vue {
    @Prop() toggleLoadingSpinner!: () => void
    confirmation = false
    validDocumentConfirmation = false
    paymentInProgress = false

    get canMakePayment (): boolean {
        if (this.isPassportWithCourier) {
            return this.confirmation && this.validDocumentConfirmation && !this.paymentInProgress
        }
        return this.confirmation && !this.paymentInProgress
    }

    get stateFee (): number {
        if (applicantStore.stateFee !== null) {
            return applicantStore.stateFee
        }
        throw new GeneralError(['errors.system.stateFee.message'])
    }

    get stateFeeRetrievalUrl (): string {
        return ENVIRONMENT.stateFeeRetrievalUrl[this.$i18n.locale || FALLBACK_LOCALE]
    }

    get uuid (): string {
        return applicantStore.application.uuid || ''
    }

    setIsDataConfirmed (value: boolean): void {
        if (this.uuid) {
            this.confirmConditions(this.uuid)
        }
        this.confirmation = value
    }

    setIsConfirmedValidDocument (value: boolean): void {
        if (this.uuid) {
            this.confirmValidDocument(this.uuid)
        }
        this.validDocumentConfirmation = value
    }

    async confirmConditions (uuid: string) {
        try {
            this.toggleLoadingSpinner()
            await PaymentService.confirmConditions(uuid)
        } catch {
            throw new GeneralError(['errors.request.validation.message'])
        }
        this.toggleLoadingSpinner()
    }

    async confirmValidDocument (uuid: string) {
        try {
            this.toggleLoadingSpinner()
            await PaymentService.confirmValidDocumentForCourier(uuid)
        } catch {
            throw new GeneralError(['errors.request.validation.message'])
        }
        this.toggleLoadingSpinner()
    }

    async validate () {
        if (!this.confirmation) {
            throw new GeneralError(['validations.confirmDataValidity'])
        }
    }

    async startPayment (bank: string) {
        this.paymentInProgress = true
        this.toggleLoadingSpinner()
        await this.validate()
        await PaymentService.confirmAndStartPayment(bank)
    }

    get hasPersonalDataChanged (): boolean {
        return (!!applicantStore.application.idCard &&
            applicantStore.application.idCard.reason === ApplicationReason.DATA_HAS_CHANGED) ||
            (!!applicantStore.application.citizenPassport &&
                applicantStore.application.citizenPassport.reason === ApplicationReason.DATA_HAS_CHANGED)
    }

    get isPensioner (): boolean {
        return applicantStore.rrInfo?.isPensioner === true
    }

    get paymentPensionerDiscountInfoUrl (): string {
        return ENVIRONMENT.paymentPensionerDiscountInfoUrl[this.$i18n.locale || FALLBACK_LOCALE]
    }

    get isPassportWithCourier (): boolean {
        return applicantStore.application.citizenPassport != null && applicantStore.application.citizenPassport.delivery.courier?.city != null
    }
}
